
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { AddressBookLookupData } from '@/models/addressBook';
import DatePicker from '@/views/Location/DatePicker.vue';

@Component({
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
  components: {
    DatePicker,
  },
})
export default class JobBookingWarehouseFieldSet extends Vue {
  @Prop({ type: Array, required: true }) public addresses!: AddressBookLookupData[];
  @Prop({ type: Array, required: true }) public value!: AddressBookLookupData[];
  @Prop({ type: String, required: true }) public date!: string;
  @Prop({ type: Boolean, required: false }) public isSameWH: boolean;

  public changeDate(date: string): void {
    this.$emit('handleDateChange', date);
  }

  public whChanged(): void {
    this.$emit('handleWHChange', this.value);
  }
}
